import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'config/constants'
import { fontWeights, space } from 'config/theme'

const TextContainer = styled.div`
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  padding: ${space.m};
  color: ${COLORS.ROCK_BLUE};
  font-weight: ${fontWeights.semi_bold};
`

const lineStyle = `
  content: '';
  flex: 1;
  height: 1px;
  background-color: ${COLORS.WHISPER_BLUE};
`

const Lines = styled.div`
  display: flex;
  align-items: center;
  ::before {
    ${lineStyle}
  }
  ::after {
    ${lineStyle}
  }
`

const DecorativeOr = () => (
  <Lines>
    <TextContainer>OR</TextContainer>
  </Lines>
)

export default DecorativeOr
